module.exports = __webpack_public_path__ + "img/流体力学3_5_4.0b0f8e15.jpg";